document.addEventListener('DOMContentLoaded', function () {
  const loginForm = document.getElementById('login');
  const recoverForm = document.getElementById('recover');
  const successEl = document.querySelector('[data-recover-success]');

  const showRecover = () => {
    if (loginForm) loginForm.hidden = true;
    if (recoverForm) recoverForm.hidden = false;
  };

  const showLogin = () => {
    if (recoverForm) recoverForm.hidden = true;
    if (loginForm) loginForm.hidden = false;
  };

  // After a successful recover POST, Shopify reloads login with the success flag.
  // Keep the login panel visible so the message is obvious.
  if (successEl) {
    showLogin();
    history.replaceState(null, null, '#login');
    successEl.focus?.();
  } else if (window.location.hash === '#recover') {
    showRecover();
  } else {
    showLogin();
  }

  document.querySelectorAll('a[href="#recover"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      showRecover();
      history.replaceState(null, null, '#recover');
      document.getElementById('RecoverEmail')?.focus();
    });
  });

  document.querySelectorAll('a[href="#login"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      showLogin();
      history.replaceState(null, null, '#login');
    });
  });
});
